// src/components/PageViewCounter.jsx
import React, { useEffect, useState, useRef } from "react";
import { doc, getDoc, setDoc, updateDoc, increment } from "firebase/firestore";
import { db } from "../lib/firebaseSetup";

// 1. ฐานข้อมูลยอดวิวเดิมที่คุณเคยจดไว้ (Base Views)
const baseViewsData = {
  // "607": 1500
};

export default function PageViewCounter({ id, t }) {
  const [totalViews, setTotalViews] = useState(null);
  const hasCountedRef = useRef(false);

  useEffect(() => {
    if (!id || hasCountedRef.current) return;

    const recordView = async () => {
      try {
        hasCountedRef.current = true; 
        
        const baseViews = baseViewsData[id] || 0;
        const viewRef = doc(db, "book_views", id);
        
        // 🔑 [จุดป้องกัน F5] สร้าง Key เฉพาะสำหรับหนังสือเล่มนี้
        const storageKey = `viewed_book_${id}`;
        const hasViewedInSession = sessionStorage.getItem(storageKey);

        if (hasViewedInSession) {
          // 🚫 ถ้าเคยเข้าหน้านี้แล้วในเซสชันนี้: ดึงยอดล่าสุดมาโชว์อย่างเดียว "ไม่ดึง Firebase ไปอัปเดตเพิ่ม"
          const docSnap = await getDoc(viewRef);
          if (docSnap.exists()) {
            setTotalViews(docSnap.data().count + baseViews);
          } else {
            setTotalViews(baseViews);
          }
        } else {
          //  ถ้ายังไม่เคยเข้าในเซสชันนี้: ทำการนับยอดวิวเพิ่มตามปกติ
          const docSnap = await getDoc(viewRef);

          if (docSnap.exists()) {
            await updateDoc(viewRef, { count: increment(1) });
            setTotalViews(docSnap.data().count + 1 + baseViews);
          } else {
            await setDoc(viewRef, { count: 1 });
            setTotalViews(1 + baseViews);
          }

          // 💾 บันทึกจำไว้ในเบราว์เซอร์ว่าหน้านี้ถูกนับไปแล้ว
          sessionStorage.setItem(storageKey, "true");
        }
      } catch (error) {
        console.error("Error updating page views:", error);
      }
    };

    recordView();

    return () => {
      hasCountedRef.current = false;
    };
  }, [id]);

  if (totalViews === null) return null;

  return (
    <div className="flex items-center gap-2 text-[#cfbca8] font-['DM_Sans',_sans-serif]">
      <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
        <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z"/>
        <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"/>
      </svg>
      <span>ยอดเข้าชม {totalViews.toLocaleString()} ครั้ง</span>
    </div>
  );
}